class GenericUpdatePage
{

    static CurrentAudio;

    static init()
    {
        GenericUpdatePage.setupScrollAnimations();
        GenericUpdatePage.setupMusicKitPreviews();
    }

    static setupMusicKitPreviews()
    {
        document.querySelectorAll('[data-music-kit-preview="1"]').forEach(function(element) {
            element.addEventListener('click', function(e) {
                e.preventDefault();
        
                var url = this.getAttribute("data-music-url");
        
                if (GenericUpdatePage.CurrentAudio && !GenericUpdatePage.CurrentAudio.paused) {
                    GenericUpdatePage.CurrentAudio.pause();
                }
        
                GenericUpdatePage.CurrentAudio = new Audio(url);
                GenericUpdatePage.CurrentAudio.volume = 0.2;
                GenericUpdatePage.CurrentAudio.play();
            });
        });
        

    }

    static setupScrollAnimations()
    {
        let observer = new IntersectionObserver((entries, observer) => {

            entries.forEach(entry => {

                if(entry.isIntersecting)
                {
                    entry.target.classList.add('show-animation');
                }
                else
                {
                    entry.target.classList.remove('show-animation');
                }

            });

        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        });

        document.querySelectorAll('.scroll-animation').forEach((element) => {
            observer.observe(element);
        });

    }

}

export default GenericUpdatePage;